import { render, staticRenderFns } from "./paUser.vue?vue&type=template&id=2c4c0177&scoped=true&"
import script from "./paUser.vue?vue&type=script&lang=js&"
export * from "./paUser.vue?vue&type=script&lang=js&"
import style0 from "./paUser.vue?vue&type=style&index=0&id=2c4c0177&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4c0177",
  null
  
)

component.options.__file = "paUser.vue"
export default component.exports